import { useUrlGenerator } from '@folklore/routes';

import useTanQuery from './useTanQuery';

const useFavorites = (config) => {
    const route = useUrlGenerator();
    const url = route('favorites.index');
    return useTanQuery('favorites', url, config);
};

export default useFavorites;
